import {getProjectCandidateStatuses} from "store/project/projectAsyncActions";
import {projectSelector} from "store/project-list/projectListSelectors";
import {
	activeSearchRequestSelector,
	additionalProfileFiltersSelector,
	additionalProfileResultsSelector,
	AdditionalProfilesPaginationInfoSelector,
} from "store/additional-profiles/additionalProfilesSelectors";
import mapxProfileRequestsApi from "api/projectApi/profileRequestApi";
import {setAPActiveResult} from "store/additional-profiles/additionalProfilesActions";
import {
	getAPRejectedProfilesByProjectId,
	removeCandidateFromRejectedList,
} from "store/additional-profiles/rejectedProfilesAsyncActions";
import {buildCandidateApiRequestPayload} from "helpers/filterHandlers";
import {
	fetchTargetListCompanyIDs,
	getTargetListCompanies,
	saveCandidatesByFilters,
} from "store/target-list/targetListAsyncActions";
import {TAppDispatch, TRootState} from "types";
import {SICandidate} from "api/candidateApi/types";
import {
	getSearchRequestDetails,
	getSearchRequestedProfilesByQuery,
} from "store/additional-profiles/searchRequestAsyncActions";
import {STCandidateDecisionData} from "api/projectApi/profileRequestApi/types";
import {ICandidateSearchApiRequestPayload} from "api/candidateApi/form";
import queryString from "qs";
import projectCandidateApi from "api/projectApi/projectCandidatesApi";
import {STProject} from "api/projectApi/types";
import {TUpdateProjectCandidateInfoForm} from "api/projectApi/projectCandidatesApi/types";
import {successResponse} from "helpers/map";
import {updateMultipleProjectSuccessChecklistItems} from "store/project/projectSuccessChecklistAsyncActions";
import {TUpdateProjectSuccessChecklistItemParam} from "mapx-components/Layouts/ProjectChecklist/types";
import {
	getProjectCandidateStatusesFailed,
	getProjectCandidateStatusesInit,
	setAPCandidatesWithUpdatedRecommendedCandidates,
} from "store/project/projectActions";
import {
	fetchTargetListCandidateIDs,
	getTargetListCandidates,
} from "store/target-list/targetListCandidatesAsyncActions";

export {
	getAPRejectedProfilesByProjectId,
	removeCandidateFromRejectedList,
} from "store/additional-profiles/rejectedProfilesAsyncActions";

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const preparePayloadForCurrentSearch = () => (_: any, getState: () => TRootState) => {
	const state = getState();

	const activeSearchRequest = activeSearchRequestSelector(state);

	const filtersInState = additionalProfileFiltersSelector(state);

	try {
		let filters = {...filtersInState};

		filters = {...filters, found_by_search_request: [activeSearchRequest?.id]};

		return buildCandidateApiRequestPayload(filters);
	} catch (e) {
		console.log(e);
	}

	return null;
};

export const removeCandidateFromAPList =
	(candidateId: number) => (dispatch: TAppDispatch, getState: () => TRootState) => {
		const state = getState();
		const results = additionalProfileResultsSelector(state);
		const pagination = AdditionalProfilesPaginationInfoSelector(state);

		const data = {
			pagination: {
				...pagination,
				count: pagination.count - 1,
			},
			results: [...results].filter((item: SICandidate) => item.id !== candidateId),
		};

		dispatch(setAPActiveResult(data));
	};
export const approveORejectAllCandidates =
	(isApproveAll: boolean) => async (dispatch: TAppDispatch, getState: () => TRootState) => {
		const state = getState();

		const project = projectSelector(state) as STProject as STProject;

		try {
			const apiPayload = dispatch(preparePayloadForCurrentSearch()) as unknown as Omit<
				ICandidateSearchApiRequestPayload,
				"pagination"
			>;

			if (apiPayload === null) {
				throw new Error("API payload can not be null when saving all or reject all");
			}

			const formData: STCandidateDecisionData = {
				status: isApproveAll ? "Approved" : "Rejected",
			};

			const queryParams = queryString.stringify(
				{
					...apiPayload.filters,
					...apiPayload.sorting_options,
				},
				{
					indices: false,
					arrayFormat: "comma",
					addQueryPrefix: true,
				},
			);

			if (isApproveAll) {
				await dispatch(saveCandidatesByFilters(apiPayload, false));
			} else {
				await mapxProfileRequestsApi.rejectCandidatesOnSearchRequests(
					project.id,
					queryParams,
					formData,
				);
			}
			await dispatch(getSearchRequestedProfilesByQuery(apiPayload, 1));

			const activeSearchRequest = activeSearchRequestSelector(state);
			dispatch(getSearchRequestDetails(activeSearchRequest.id));
		} catch (e) {
			console.log(`Error from modifying save or reject all Profile status: ${e}`);
		}
	};
/**
 * APPROVE CANDIDATE ON ADDITIONAL PROFILES RESULT
 * @param candidateId
 * @param removeFromRejectList
 */

export const approveCandidate =
	(candidateId: number, removeFromRejectList = false) =>
	async (dispatch: TAppDispatch, getState: () => TRootState) => {
		const state = getState();
		const project = projectSelector(state) as STProject as STProject;

		let response;

		try {
			const formData: STCandidateDecisionData = {status: "Approved"};

			response = await mapxProfileRequestsApi.modifyAdditionalProfileStatus(
				project.id,
				candidateId,
				formData,
			);

			if (response?.data) {
				await dispatch(getTargetListCompanies());

				dispatch(fetchTargetListCompanyIDs());

				if (removeFromRejectList) {
					dispatch(removeCandidateFromRejectedList(candidateId));
				} else {
					dispatch(removeCandidateFromAPList(candidateId));
				}

				const updates: TUpdateProjectSuccessChecklistItemParam[] = [
					{attribute: "has_saved_people", value: true},
					{attribute: "has_saved_companies", value: true},
				];

				dispatch(updateMultipleProjectSuccessChecklistItems(updates));
			} else {
				window.alert("Something went wrong");
			}
		} catch (e) {
			console.log(`Error from getting all Profile request: ${e}`);
		}
	};

export const recommendCandidate =
	(candidateId: number, recommendCandidate: boolean) =>
	async (dispatch: TAppDispatch, getState: () => TRootState) => {
		const state = getState();

		dispatch(getProjectCandidateStatusesInit());

		const project = projectSelector(state) as STProject;

		let response;

		try {
			const formData: TUpdateProjectCandidateInfoForm = {
				is_recommended: recommendCandidate,
			};

			response = await projectCandidateApi.updateCandidateInfoByCandidateId(
				project.id,
				candidateId,
				formData,
			);

			if (successResponse(response, 200)) {
				const payload = {
					id: candidateId,
					is_recommended: recommendCandidate,
				};

				dispatch(setAPCandidatesWithUpdatedRecommendedCandidates(payload));
				// The status counts include "recommended"; refresh them so counters stay true
				dispatch(getProjectCandidateStatuses());

				return "success";
			} else {
				return "error";
			}
		} catch (e) {
			console.log(`Error from click recommend candidate: ${e}`);
			dispatch(getProjectCandidateStatusesFailed());

			return "error";
		}
	};
/**
 * REJECT CANDIDATE ON ADDITIONAL PROFILES RESULT
 * @param candidate
 */

export const rejectCandidate =
	(candidate: SICandidate) => async (dispatch: TAppDispatch, getState: () => TRootState) => {
		const state = getState();

		const project = projectSelector(state) as STProject as STProject;

		let response;

		const candidateId = candidate.id;

		try {
			const formData: STCandidateDecisionData = {status: "Rejected"};

			response = await mapxProfileRequestsApi.modifyAdditionalProfileStatus(
				project.id,
				candidateId,
				formData,
			);

			if (response?.data) {
				await dispatch(getTargetListCandidates());

				dispatch(fetchTargetListCandidateIDs());

				dispatch(removeCandidateFromAPList(candidateId));

				dispatch(getAPRejectedProfilesByProjectId(project.id));
			} else {
				window.alert("Something went wrong");
			}
		} catch (e) {
			console.log(`Error from getting all Profile request: ${e}`);
		}
	};
